// Flagged Enum
export var PaymentTypeRestrictions;
(function (PaymentTypeRestrictions) {
    PaymentTypeRestrictions[PaymentTypeRestrictions["None"] = 0] = "None";
    PaymentTypeRestrictions[PaymentTypeRestrictions["Checking"] = 1] = "Checking";
    PaymentTypeRestrictions[PaymentTypeRestrictions["Debit"] = 2] = "Debit";
    PaymentTypeRestrictions[PaymentTypeRestrictions["Credit"] = 4] = "Credit";
    PaymentTypeRestrictions[PaymentTypeRestrictions["Cards"] = 6] = "Cards";
})(PaymentTypeRestrictions || (PaymentTypeRestrictions = {}));
//# sourceMappingURL=PaymentTypeRestrictions.js.map